import React from "react";

const SocialDetails=()=>{

    return(
        <>
        </>
    )
}

export default SocialDetails
